import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ClockCounterClockwise } from "@phosphor-icons/react";
import Layout from "../components/Layout";
import EmptyState from "../components/EmptyState";
import api from "../lib/api";
import { fmtCurrency, fmtNumber, fmtDateTime, fmtDateShort } from "../lib/format";

export default function UploadHistory() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/uploads").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  if (rows === null) {
    return (
      <Layout title="Upload History">
        <div className="h-64 animate-pulse rounded-lg border border-slate-200 bg-white" />
      </Layout>
    );
  }

  if (rows.length === 0) {
    return (
      <Layout title="Upload History">
        <EmptyState icon={ClockCounterClockwise} title="No uploads yet" message="Uploaded files and their audit trail will appear here." testId="history-empty" />
      </Layout>
    );
  }

  return (
    <Layout title="Upload History">
      <div className="animate-fade-in rounded-lg border border-slate-200 bg-white" data-testid="history-table">
        <div className="thin-scroll overflow-x-auto">
          <table className="w-full min-w-[820px]">
            <thead>
              <tr className="border-b border-slate-100 bg-slate-50/60 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                <th className="px-4 py-3">File</th>
                <th className="px-4 py-3">Business Date(s)</th>
                <th className="px-4 py-3">Uploaded By</th>
                <th className="px-4 py-3">When</th>
                <th className="px-4 py-3 text-right">Rows</th>
                <th className="px-4 py-3 text-right">Bills</th>
                <th className="px-4 py-3 text-right">Sales</th>
                <th className="px-4 py-3 text-right">Returns</th>
                <th className="px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((b) => (
                <tr key={b.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`history-row-${b.upload_id}`}>
                  <td className="px-4 py-3 text-sm font-medium text-slate-800">{b.file_name}</td>
                  <td className="px-4 py-3 text-sm text-slate-600">{(b.business_dates || []).map(fmtDateShort).join(", ")}</td>
                  <td className="px-4 py-3 text-sm text-slate-600">{b.uploaded_by}</td>
                  <td className="whitespace-nowrap px-4 py-3 text-xs text-slate-500">{fmtDateTime(b.uploaded_at)}</td>
                  <td className="px-4 py-3 text-right font-mono-data text-sm">{fmtNumber(b.row_count)}</td>
                  <td className="px-4 py-3 text-right font-mono-data text-sm">{fmtNumber(b.bill_count)}</td>
                  <td className="px-4 py-3 text-right font-mono-data text-sm">{fmtCurrency(b.sales_amount)}</td>
                  <td className="px-4 py-3 text-right font-mono-data text-sm text-red-600">{fmtCurrency(b.return_amount)}</td>
                  <td className="px-4 py-3">
                    <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
                      b.status === "completed" ? "bg-emerald-100 text-emerald-700" :
                      b.status === "replaced" ? "bg-slate-200 text-slate-500" : "bg-slate-100 text-slate-600"
                    }`}>
                      {b.status}{b.replaced ? " (replaced prev)" : ""}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
